/** @format */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const RaceSettingsPage = lazyWithRetry(
  () => import("@/pages/RaceSettings/RaceSettings")
);

export const Route = createFileRoute("/race/$raceId/settings")({
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <RaceSettingsPage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
});
